import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessPostReq extends EntityRequestExpenses {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
